import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';

const SERVICES = [
  'Database',
  'Perplexity Sonar',
  'Apollo enrichment',
  'S3',
  'Stripe',
];

export default function Health() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-text-primary">System Health</h1>
        <p className="text-sm text-text-secondary mt-1">
          Dependencies, lifecycle runs, errors — auto-refresh disabled until backend endpoints ship.
        </p>
      </div>

      {/* Services row */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Services</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-3">
            {SERVICES.map((svc) => (
              <div
                key={svc}
                className="flex flex-col items-center gap-2 p-4 rounded-lg border border-border bg-surface min-w-[100px]"
              >
                {/* Neutral grey status dot */}
                <span className="w-3 h-3 rounded-full bg-text-muted/40 flex-shrink-0" />
                <span className="text-sm font-medium text-text-primary text-center">{svc}</span>
                <span className="text-xs text-text-muted">Status pending</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Stub: Live runs feed */}
      <Card className="border-dashed">
        <CardHeader>
          <CardTitle className="text-base">Live runs feed</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-text-muted italic">
            Backend endpoint pending: needs <code className="font-mono text-xs bg-surface px-1 py-0.5 rounded">GET /adm/runs?since=X</code> for streaming recent lifecycle calls.
          </p>
        </CardContent>
      </Card>

      {/* Stub: Error stream */}
      <Card className="border-dashed">
        <CardHeader>
          <CardTitle className="text-base">Error stream</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-text-muted italic">
            Backend endpoint pending: needs <code className="font-mono text-xs bg-surface px-1 py-0.5 rounded">GET /adm/errors</code> for grouped error tracking.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
